import type { IPptBarChartOptions } from "app/services/PptExportService/PptExportServiceTypes";

export const getBarChartWidgetPptOptions = (): IPptBarChartOptions => {
    return {
        showLegend: true,
        showValuesOnChart: false,
    };
};
